import React, { useContext } from 'react';
// Contexts
import { ResponsiveContext } from '~/contexts/ResponsiveContext';
// Own Components
import AddButton from './components/AddButton';
// Components
import Space from '~/components/space';
import Card from '~/components/card';
import Title from '~/components/typography/title';
import Search from '~/components/search';

export default function Header({ setSearchInput, GetDataAgain, loadingSearch }) {
  const { isMobile } = useContext(ResponsiveContext);

  function onSearch(value) {
    if (value.length === 0) {
      setSearchInput(value)
    }
    if (value.length > 2) {
      setSearchInput(value)
    }
  }

  return (
    <Card bodyStyle={{ padding: 10 }} style={{ marginBottom: 10 }}>
      <div style={
        isMobile ?
          { display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }
          :
          { display: 'flex', justifyContent: 'space-between' }}
      >
        <Title level={4} style={{ margin: isMobile ? '0px 0px 10px' : 0 }}>
          Meus Modelos de Documentos
        </Title>
        <Space align={isMobile ? 'center' : 'auto'} direction={isMobile ? 'vertical' : 'horizontal'}>
          <Search loading={loadingSearch} onSearch={(value) => onSearch(value)} enterButton />
          <AddButton GetDataAgain={GetDataAgain} />
        </Space>
      </div>
    </Card>
  );
}
